import { faClipboardListCheck, faInboxIn, faInboxOut, faPaperPlane, faRoute, faTrashAlt, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import _ from 'lodash';
import { Enum, EnumType } from 'ts-jenum';
import { WellKnownFolderEnum } from '../../../samwebDescription/samwin/well-known-folder-enum';

@Enum<MailingFolderEnum>('name')
export class MailingFolderEnum extends EnumType<MailingFolderEnum>() {
   static readonly INBOX = new MailingFolderEnum(
      'INBOX',
      faInboxIn,
      'brick.brick_definitions.skill-browser-mail.categories.inbox',
      WellKnownFolderEnum.INBOX.value
   );
   static readonly TRACKING = new MailingFolderEnum(
      'TRACKING',
      faRoute,
      'brick.brick_definitions.skill-browser-mail.categories.tracking',
      WellKnownFolderEnum.TRACKING.value
   );
   static readonly COMPLETED = new MailingFolderEnum(
      'COMPLETED',
      faClipboardListCheck,
      'brick.brick_definitions.skill-browser-mail.categories.completed',
      WellKnownFolderEnum.COMPLETED.value
   );
   static readonly OUTBOX = new MailingFolderEnum(
      'OUTBOX',
      faInboxOut,
      'brick.brick_definitions.skill-browser-mail.categories.outbox',
      WellKnownFolderEnum.OUTBOX.value
   );
   static readonly SENT = new MailingFolderEnum(
      'SENT',
      faPaperPlane,
      'brick.brick_definitions.skill-browser-mail.categories.sent',
      WellKnownFolderEnum.SENT.value
   );
   static readonly DELETED = new MailingFolderEnum(
      'DELETED',
      faTrashAlt,
      'brick.brick_definitions.skill-browser-mail.categories.deleted',
      WellKnownFolderEnum.DELETED.value
   );

   private constructor(public name: string, public icon: IconDefinition, public translation: string, public value: number) {
      super();
   }
}
